// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import { application } from './application';

import AddressAutocompleteController from './address_autocomplete_controller.js';
import ApiAutocompleteController from './api_autocomplete_controller.js';
import AutoSlideOverController from './auto_slide_over_controller.js';
import AutoSubmitController from './auto_submit_controller.js';
import BankAccountToggleController from './users/bank_account_toggle_controller.js';
import CarouselStimulusController from './components/stimulus_carousel.js';
import ChangeDistributorController from './distributors/change_distributor_controller.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import DateMaxValidationController from './date_max_validation_controller.js';
import DistributorFormController from './admin/users/distributors/form_controller.js';
import FlashController from './flash_controller.js';
import DropdownMenuController from './admin/dropdown_menu_controller.js';
import FileInputController from './file_input_controller.js';
import FundsCheckController from './admin/dashboard/funds_check_controller.js';
import GenerateTokenController from './generate_token_controller.js';
import GtmController from './gtm_controller.js';
import FrameModalController from './frame_modal_controller.js';
import InvestFormController from './invest_form_controller.js';
import ModalStepsController from './modal_steps_controller.js';
import ProfileSelectorController from './profile_selector_controller.js';
import ScrollToTabsController from './scroll_to_tabs_controller.js';
import ScrollspyNavController from './scrollspy_nav_controller.js';
import LemonwayIframeController from './users/profile_information/onboarding/lemonway_iframe_controller.js';
import LendingTimetableFormController from './lending_time_table_controller.js';
import NativeInformationsFormCardController
  from './users/profile_information/native_informations_form_card_controller.js';
import NestedFormController from './nested_form_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import PoliticalExpositionController from './political_exposition_controller.js';
import ProjectSectionSelectorController from './admin/project_section_selector_controller.js';
import RedactorController from './redactor_controller.js';
import ResizeHandleController from './resize_handle_controller.js';
import SignatureChannelController from './signature_channel_controller.js';
import SidebarController from './sidebar_controller.js';
import SubscriptionIntentionChannelController from './subscription_intention_channel_controller.js';
import SpecialPurposeVehicleFormController from './admin/special_purpose_vehicle_form_controller.js';
import TableDropdownController from './table_dropdown_controller.js';
import TomSelectController from './tom_select_controller.js';
import TooltipController from './tooltip_controller.js';
import TurboReinitController from './turbo_reinit_controller.js';
import WelcomeModalController from './users/welcome_modal_controller.js';
import PhoneNumberController from './users/profile_information/phone_number_controller.js';
import ActiveRadioController from './users/profile_information/active_radio_controller.js';
import KycFileFeedbackController from './users/profile_information/kyc_documents/file_feedback_controller.js';
import SubscriptionModalController from './distributors/subscription_modal_controller.js';
import LegalEntityLookupController from './legal_entity_lookup_controller.js';
import KeyboardNavController from './keyboard_nav_controller.js';
import OperationsExportController from './operations_export_controller.js';
import PagyInitializerController from './pagy_initializer_controller.js';
import FadeInController from './fade_in_controller.js';
import PayoutFunnelController from './payout_funnel_controller.js';
import TurboRedirectController from './turbo_redirect_controller.js';
import SnapNavigationController from './snap_navigation_controller.js';
import BsModalController from './bs_modal_controller.js';
import DesignScrollspyController from './design/scrollspy_controller.js';
import IframeCallbackController from './iframe_callback_controller.js';
import ImageSkeletonController from './image_skeleton_controller.js';
import InfiniteScrollController from './infinite_scroll_controller.js';
import LemonwayPaymentController from './lemonway_payment_controller.js';
import ProgressBarController from './progress_bar_controller.js';
import OtpCountdownController from './otp_countdown_controller.js';
import OtpInputController from './otp_input_controller.js';
import ProfileMenuController from './profile_menu_controller.js';
import BridgeModalController from './bridge/modal_controller.js';
import BridgeSheetController from './bridge/sheet_controller.js';
import PushPromptController from './bridge/push_prompt_controller.js';
import ChartController from './chart_controller.js';

application.register('chart', ChartController);
application.register('address-autocomplete', AddressAutocompleteController);
application.register('api-autocomplete', ApiAutocompleteController);
application.register('auto-slide-over', AutoSlideOverController);
application.register('auto-submit', AutoSubmitController);
application.register('carousel-stimulus', CarouselStimulusController);
application.register('political-exposition', PoliticalExpositionController);
application.register('tom-select', TomSelectController);
application.register('tooltip', TooltipController);
application.register('turbo-reinit', TurboReinitController);
application.register('sidebar', SidebarController);
application.register('signature-channel', SignatureChannelController);
application.register('subscription-intention-channel', SubscriptionIntentionChannelController);
application.register('table-dropdown', TableDropdownController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register(
  'native-informations-form-card',
  NativeInformationsFormCardController
);
application.register('nested-form', NestedFormController);
application.register('redactor', RedactorController);
application.register('resize-handle', ResizeHandleController);
application.register('password-visibility', PasswordVisibilityController);
application.register(
  'project-section-selector',
  ProjectSectionSelectorController
);
application.register('lemonway-iframe', LemonwayIframeController);
application.register(
  'special-purpose-vehicle-form',
  SpecialPurposeVehicleFormController
);
application.register('frame-modal', FrameModalController);
application.register('invest-form', InvestFormController);
application.register('modal-steps', ModalStepsController);
application.register('profile-selector', ProfileSelectorController);
application.register('scroll-to-tabs', ScrollToTabsController);
application.register('scrollspy-nav', ScrollspyNavController);
application.register('distributor-form', DistributorFormController);
application.register('dropdown-menu', DropdownMenuController);
application.register('file-input', FileInputController);
application.register('flash', FlashController);
application.register('generate-token', GenerateTokenController);
application.register('gtm', GtmController);
application.register('funds-check', FundsCheckController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('date-max-validation', DateMaxValidationController);
application.register('welcome-modal', WelcomeModalController);
application.register('bank-account-toggle', BankAccountToggleController);
application.register('change-distributor', ChangeDistributorController);
application.register('phone-number', PhoneNumberController);
application.register('active-radio', ActiveRadioController);
application.register('kyc-file-feedback', KycFileFeedbackController);
application.register('subscription-modal', SubscriptionModalController);
application.register('legal-entity-lookup', LegalEntityLookupController);
application.register('keyboard-nav', KeyboardNavController);
application.register('operations-export', OperationsExportController);
application.register('pagy-initializer', PagyInitializerController);
application.register('snap-navigation', SnapNavigationController);
application.register('fade-in', FadeInController);
application.register('payout-funnel', PayoutFunnelController);
application.register('turbo-redirect', TurboRedirectController);
application.register('bs-modal', BsModalController);
application.register('design--scrollspy', DesignScrollspyController);
application.register('iframe-callback', IframeCallbackController);
application.register('image-skeleton', ImageSkeletonController);
application.register('infinite-scroll', InfiniteScrollController);
application.register('lemonway-payment', LemonwayPaymentController);
application.register('progress-bar', ProgressBarController);
application.register('otp-countdown', OtpCountdownController);
application.register('otp-input', OtpInputController);
application.register('profile-menu', ProfileMenuController);
application.register('bridge--modal', BridgeModalController);
application.register('bridge--sheet', BridgeSheetController);
application.register('bridge--push-prompt', PushPromptController);
